import {getSelectorParts} from '../property-selectors';
import {getHostVariables, isComputedProperty} from './index';
import {PROPERTY_DEFS} from '../symbols';

/**
 * Util function to determine if a resolved selected property should be added to the mapping
 * If provider's property is computed, it always needs to be recalculated at runtime
 * So returns false
 * @param propValue
 * @param componentRegistry
 * @returns {boolean}
 */
export default function shouldAddToResolvedPropertyMapping(propValue, componentRegistry) {
	const [id, name] = getSelectorParts(propValue);
	const component = componentRegistry[id];
	if (!component) return false;

	return !isComputedProperty(name, getHostVariables(component)?.[PROPERTY_DEFS]);
}
